import script from "./GlobalToastContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalToastContainer.vue?vue&type=script&setup=true&lang=ts"

import "./GlobalToastContainer.vue?vue&type=style&index=0&id=b9b33b66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9b33b66"]])

export default __exports__